import { Link } from 'gatsby';
import React, { ReactElement, useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';
import { Headline } from '../../components';
import { formatUrl } from '../../utilities/';

interface IProps {
  title: string;
  headerBgColor: string;
  headerTextColor: string;
  headerIllo: string;
}

// The fancy card displayed for a library collection containing a title
// and an illo image
export default function CollectionsCard({
  title,
  headerBgColor = 'blue',
  headerTextColor = 'white',
  headerIllo,
}: IProps): ReactElement {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (mediaQuery && !mediaQuery.matches) {
      const elements = document.querySelectorAll('.js-tilt');
      //@ts-ignore
      VanillaTilt.init(elements);
    }
  }, []);

  return (
    <Link
      to={`/library/collections/${formatUrl(title)}/`}
      className={`collections-card js-tilt relative h-[350px] overflow-hidden rounded-lg border border-transparent p-8 no-underline will-change-transform hover:border-neutral-gray-100 focus:border-neutral-gray-100 bg-base-${headerBgColor}`}
      style={{
        transform:
          'perspective(500px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
        transformStyle: 'preserve-3d',
      }}
      data-tilt
      data-tilt-glare="true"
      data-tilt-max-glare="0.35"
      data-tilt-speed="1000"
      data-tilt-max="10"
      data-tilt-scale="1.03"
      data-tilt-perspective="1500">
      <Headline
        level="4"
        className={`text-type-${headerTextColor} relative z-10 block`}
        style={{ transform: 'translateZ(20px)' }}>
        {title}
      </Headline>
      <img
        className="collections-card__image width-[261px] absolute bottom-0 left-0"
        loading="lazy"
        alt=""
        src={headerIllo}
      />
    </Link>
  );
}
